export default "__VITE_ASSET__a8cd9ae8__"